export default [
  {
    route: 'store-food-dashboard',
    title: 'store-food-dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    resource: 'Store-food-dashboard',
    action: 'read',
  },
]
